/* eslint-disable pii/no-phone-number */
import React from "react";
import PropTypes from "prop-types";
import Signature from "./Signature";

const translationStyle = { lineHeight: 2 };

const Declaration = ({ renderValue, employeeParticulars }) => (
  <table className="normalPadded" style={{ borderCollapse: "collapse", width: "100%" }}>
    <tbody>
      <tr>
        <td style={{ paddingLeft: 0, paddingRight: 0 }} colSpan={11}>
          <div
            style={{
              fontWeight: "bold",
              paddingTop: 10,
              paddingBottom: 10,
            }}
          >
            DECLARATION AND AUTHORISATION 聲明及授權
          </div>
          <div style={{ fontSize: "14px" }}>
            <div style={{ paddingBottom: 10 }}>
              <b>I HEREBY APPLY</b> for insurance to which I may become entitled under the terms of
              the Employee Benefits Insurance Policy. I understand that the insurance applied for
              shall not be in force unless this application is accepted by <b>AXA</b> China Region
              Insurance Company Limited (<b>“the Company”</b>). I authorise my Employer to deduct
              from my earnings (1) any contribution I am required to make towards the cost of the
              insurance, and (2) any charges incurred by me or my dependants which are in excess of
              the benefits provided or in respect of benefits which are not payable under the terms
              of the Employee Benefits Health Insurance Policy, and to pay the same to the Company.
            </div>
            <div style={{ paddingBottom: 10, ...translationStyle }}>
              本人依據安盛僱員福利保險保單之條款申請此項保險。本人明瞭除非安盛金融有限公司（{" "}
              <b>“貴公司”</b>）接納此申請，
              否則此項保險將不會生效。本人授權本人之僱主由本人之薪酬中扣除以下項目：（1）本人應繳付之保費；
              （2）由本人或本人之家屬引致超越保險計劃內所包括或不在計劃範圍內包括之醫療費用，本人將支付有關的費用給貴公司。
            </div>
            <div style={{ paddingBottom: 10 }}>
              <b>I HEREBY DECLARE AND AGREE</b> on behalf of myself, my dependants and other persons
              referred to this application (<b>“Relevant Persons”</b>) that all statements and
              answers to all questions whether or not written by my own hand are to the best of my
              knowledge and belief complete and true.
            </div>
            <div style={{ paddingBottom: 10, ...translationStyle }}>
              本人謹此代表本人及本人之家屬及其他在此投保申請表格提及之人士（<b>“相關人士”</b>{" "}
              ）聲明及同意上述一切陳述及問題的所有答案，
              不論是否本人親手所寫，就本人所知所信，均為事實之全部並確實無訛。
            </div>
            <div style={{ paddingBottom: 10 }}>
              <b>I HEREBY AUTHORISE</b> on behalf of myself and my dependants (1) any employer,
              medical practitioner, hospital, clinic, insurance company, bank, government
              institution, or other organisation, institution or person, that has any records or
              knowledge of myself and my dependants and/or who has attended or may hereafter attend
              to me and my dependants to disclose such information to the Company; (2) the Company
              or any of its appointed medical examiners or laboratories to perform the necessary
              medical assessments and tests to evaluate the health status of myself and my
              dependants in relation to this application and any claim arising therefrom. This
              authorisation shall bind the successors of myself and my dependants and remains valid
              notwithstanding death or incapacity. A photocopy of this authorisation shall be as
              valid as the original.
            </div>
            <div style={{ paddingBottom: 10, ...translationStyle }}>
              本人謹此代表本人及本人之家屬授權（1）任何僱主、西醫、醫院、診所、保險公司、銀行、政府機構、
              或其他組織、機構或人士、凡知道或持有本人及本人之家屬，及／或曾診驗或可能將會診驗本人及本人之家屬，
              均可將該等資料提供給安盛金融；（2）貴公司或任何其指定之醫生、醫療人員或化驗所，
              可就此投保申請表格或任何與之有關的賠償申請替本人及本人之家屬進行所需之醫療評估及測試，
              作為審核本人及本人之家屬之健康狀況。此授權對本人及本人之家屬之繼承具有約束力；
              即使本人及本人之家屬死亡或無行為能力時。此授權仍具效力。本授權書的影印本與正本均有同等效力。
            </div>
            <div style={{ paddingBottom: 10 }}>
              If the Relevant Persons fail to provide any information requested in this application,
              it may result in the Company’s inability to accept this application.
              <br />
              <div style={translationStyle}>
                {" "}
                如相關人士不能提供任何此投保申請表格所需的資料，本公司可能因此不能接受此投保申請。
              </div>
            </div>
            <div style={{ paddingBottom: 10 }}>
              <b>I DECLARE AND AGREE</b> that I have the full authority from and consent of the
              Relevant Persons to make the above declarations, agreements and authorisations.
              <div style={translationStyle}>
                {" "}
                本人聲明及同意已獲相關人士授權及同意本人作出上述聲明，協議及授權。
              </div>
            </div>
          </div>

          <br />
          <Signature renderValue={renderValue} employeeParticulars={employeeParticulars} />
          <br />
          <div
            style={{
              left: 0,
              right: 0,
              borderBottom: "1px solid black",
              textAlign: "center",
              paddingTop: 30,
            }}
          >
            In case of discrepancies between the English and Chinese versions, the English version
            shall prevail. 本表格之中英文本如有歧異，概以英文本為準。
          </div>
          <div style={{ textAlign: "left", fontSize: "12pt", paddingTop: 10 }}>
            <b>AXA China Region Insurance Company Limited 安盛金融有限公司</b>
            <br />
            <b>Employee Benefits</b>&nbsp;&nbsp;&nbsp;&nbsp;10 - 11/F, Vertical Sq, 28 Heung Yip
            Road, Wong Chuk Hang, Hong Kong
            <br />
            <div style={translationStyle}>
              <b>僱員福利</b>&nbsp;&nbsp;&nbsp;&nbsp;香港黃竹坑香葉道 28
              號嘉尚匯10至11字樓&nbsp;&nbsp;Tel 電話 (852) 2519 1166&nbsp;&nbsp;Fax 圖文傳真 (852)
              2598 6502
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
);

Declaration.propTypes = {
  renderValue: PropTypes.func.isRequired,
  employeeParticulars: PropTypes.object,
};

export default Declaration;



// WEBPACK FOOTER //
// ./components/employee/hdf-forms/Axa/AXAHD202404/Declaration.js